import { motion } from "framer-motion";
import { Building2, ShoppingBag, Wrench, BadgeCheck, CarFront } from "lucide-react";
import { useLang } from "../../lib/i18n";

const SERVICE_ICONS = [Building2, ShoppingBag, Wrench, BadgeCheck, CarFront];

export const ServicesSection = () => {
    const { t, fs } = useLang();

    return (
        <section id="services" className="relative py-24 sm:py-32 bg-[#0C1634] border-y border-white/5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-14 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
                >
                    <div>
                        <p className="font-mono-spec text-xs tracking-[0.3em] text-amber-400 mb-3" dir="ltr">
                            {t("srv_eyebrow")}
                        </p>
                        <h2 className={`font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-white max-w-xl ${fs("srv_title")}`}>
                            {t("srv_title")}
                        </h2>
                    </div>
                    <p className={`text-slate-400 text-base max-w-md ${fs("srv_desc")}`}>
                        {t("srv_desc")}
                    </p>
                </motion.div>

                <div className="grid sm:grid-cols-2 gap-5">
                    {[0, 1, 2, 3, 4].map((i) => {
                        const Icon = SERVICE_ICONS[i];
                        const number = `0${i + 1}`;
                        const s = { title: t(`srv_c${i + 1}_t`), desc: t(`srv_c${i + 1}_d`) };
                        return (
                            <motion.div
                                key={number}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                                data-testid={`service-card-${number}`}
                                className={`group relative spotlight-card border border-white/10 rounded-3xl p-7 sm:p-9 overflow-hidden hover:border-red-500/40 transition-colors duration-500 ${
                                    i % 3 === 0 ? "sm:translate-y-6" : ""
                                } ${i === 4 ? "sm:col-span-2" : ""}`}
                            >
                                <span className="absolute -top-4 -left-2 font-display font-extrabold text-[7rem] leading-none text-white/[0.04] select-none" dir="ltr">
                                    {number}
                                </span>
                                <Icon className="w-8 h-8 text-amber-400 mb-5 relative" />
                                <p className="font-mono-spec text-[10px] tracking-[0.3em] text-red-500 mb-2" dir="ltr">
                                    CHAPTER {number}
                                </p>
                                <h3 className={`font-display font-bold text-lg sm:text-xl text-white mb-3 relative ${fs(`srv_c${i + 1}_t`)}`}>
                                    {s.title}
                                </h3>
                                <p className={`text-sm text-slate-400 leading-relaxed relative ${fs(`srv_c${i + 1}_d`)}`}>{s.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
